/*
 * Copyright (c) 2023. Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.github.io/
 */

import Swal from 'sweetalert2';

function getError(error) {
    let result = '';
   // console.log('cek error: ', error.message);
    if (error.code === 'ERR_NETWORK') {
        return getErrorMessage(error.message);
    }

    const {status} = error.response;
    if (status === undefined) {
        result = 'Error - code is undefined!';
    } else if (status === 401) {
        result = 'Invalid Token!';
        localStorage.clear();
        window.location.reload()
    } else if (status === 403) {
        result = 'Forbidden Access!';
    } else if (status === 404) {
        result = 'Not Found!';
    } else if (status === 500) {
        result = 'Internal server error!';
    }
    return Swal.fire({
        icon: 'info',
        title: 'Oops...',
        text: result,
    });
}

function getResponseError(data) {
    // Ganti kata 'serviceInitial' dengan 'service Initial'
    const modifiedErrorMessage = data.replace(/serviceInitial/g, 'Service Initial');
    const modifiedErrorMessage1 = modifiedErrorMessage.replace(/personContact/g, 'Person Contact');
    const modifiedErrorMessage2 = modifiedErrorMessage1.replace(/paymentInitial/g, 'Payment Initial');

    return Swal.fire({
        icon: 'error',
        title: 'Opss...',
        text: modifiedErrorMessage2 ,
        footer: 'Please contact your system support team.',
    });
}

function getErrorMessage(message) {
    return Swal.fire({
        icon: 'error',
        title: 'Opss...',
        text: message,
        footer: 'Please contact your system support team.',
    });
}

function errorAlert(message) {
    return Swal.fire({
        title: 'Opss...',
        text: message,
        icon: 'info',
    });
}

function successAlert(message) {
    return Swal.fire({
        title: 'Okey...',
        text: message,
        icon: 'success',
    });
}

export {errorAlert, getError, getErrorMessage, getResponseError, successAlert};
